import { FlowConfig } from '../types';

export const printerFlowConfig: FlowConfig = {
  step1: {
    path: '/pdp-config',
    requirements: [],
  },
  step2: {
    path: '/cart',
    requirements: [],
  },
  step3: {
    path: '/tenant-selector',
    private: true,
    requirements: ['hasMoreThanOneTenant'],
  },
  step4: {
    path: '/claim',
    private: true,
    requirements: ['redirectToClaim'],
  },
  step5: {
    path: '/checkout',
    private: true,
    requirements: [],
  },
  step6: {
    path: '/review-subscription',
    private: true,
    requirements: ['hasIISubscription'],
    relativePath: true,
  },
  step7: {
    path: '/order',
    private: true,
    requirements: [],
  },
};
